/* Ticks every [data-xmas-countdown] present countdown (see snippets/lor-xmas-countdown.liquid). */
(function () {
  if (window.lorXmasCountdownTimer) return;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function update(el, value) {
    if (!el || el.textContent === value) return;
    el.textContent = value;
    // Restart the pop animation on each change.
    el.classList.remove('is-pop');
    void el.offsetWidth;
    el.classList.add('is-pop');
  }

  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-xmas-countdown]').forEach(function (root) {
      var deadline = Date.parse(root.getAttribute('data-xmas-countdown'));
      if (isNaN(deadline)) return;
      var left = Math.max(0, Math.floor((deadline - now) / 1000));
      root.classList.toggle('is-expired', left === 0);
      update(root.querySelector('[data-unit="d"]'), String(Math.floor(left / 86400)));
      update(root.querySelector('[data-unit="h"]'), pad(Math.floor((left % 86400) / 3600)));
      update(root.querySelector('[data-unit="m"]'), pad(Math.floor((left % 3600) / 60)));
      update(root.querySelector('[data-unit="s"]'), pad(left % 60));
    });
  }

  tick();
  window.lorXmasCountdownTimer = setInterval(tick, 1000);
})();
